import type { GenericAttachment } from '@/styles/GenericAttachmentsSection';
import { uploadEntityAttachments, fetchEntityAttachments, deleteAttachment } from '@/lib/entity-attachments';

// To-Do attachments: the shared implementation (lib/entity-attachments.ts)
// -- this file only names the entity type these files belong to.
const ENTITY_TYPE = 'task';

export type TodoFileAttachment = GenericAttachment;

export function uploadTaskAttachments(parentId: string | undefined, files: File[], companyId: string, userId: string): Promise<TodoFileAttachment[]> {
  return uploadEntityAttachments(ENTITY_TYPE, parentId, files, companyId, userId);
}

export function fetchTaskAttachments(parentId: string, opts?: { ascending?: boolean }): Promise<TodoFileAttachment[]> {
  return fetchEntityAttachments(ENTITY_TYPE, parentId, opts);
}

export function deleteTaskAttachment(attachmentId: string, userId: string | undefined): Promise<boolean> {
  return deleteAttachment(attachmentId, userId);
}
